// The two lines a form shows above its button: what went wrong (announced at once), and a calmer
// note (why the member is here). Both take words from the dictionary, or nothing.

export function ErrorLine({ text }: { text: string | undefined }) {
  if (text === undefined) return null;
  return (
    <p className="error-line" role="alert">
      {text}
    </p>
  );
}

export function NoteLine({ text }: { text: string | undefined }) {
  if (text === undefined) return null;
  return (
    <p className="note-line" role="status">
      {text}
    </p>
  );
}
